import { gql } from "@apollo/client";

const GET_GRILLA_ENVIOS = gql`
    query grillaEnvios($idDelegacion: Int!) {
        autorizar: grillaEnvios(idDelegacion: $idDelegacion, idEstado: 1) {
            idOrdenPedido
            idEvaluacion
            idPaciente
            pacienteNombre
            idCliente
            estadoDescripcion
            idDelegacion
            delegacion
            stockOrigen
            stockOrigenOpcion
            idDelegacionStockOrigen
            delegacionStockOrigen
            idModulo
            conexionesSemanales
            codSAPVenta
            umeTolerancia
            cantidadPorc
            costoInsumos
            costoUnitario
            cantidadRemitos
            gM
            resultadoPresupuesto
            fechaEntrega
            fechaAutorizar
            estadoMedico
            estadoBUM
            estadoPEnvio
            estadoComercial
            nombreUsuarioAutorizar
        }
        autorizados: grillaEnvios(idDelegacion: $idDelegacion, idEstado: 2) {
            idOrdenPedido
            idEvaluacion
            idPaciente
            pacienteNombre
            idCliente
            estadoDescripcion
            idDelegacion
            delegacion
            stockOrigen
            stockOrigenOpcion
            idDelegacionStockOrigen
            delegacionStockOrigen
            idModulo
            conexionesSemanales
            codSAPVenta
            umeTolerancia
            cantidadPorc
            costoInsumos
            costoUnitario
            cantidadRemitos
            gM
            resultadoPresupuesto
            fechaEntrega
            fechaAutorizado
            estadoMedico
            estadoBUM
            estadoPEnvio
            estadoComercial
            nombreUsuarioAutorizado
        }
    }
`;

export default GET_GRILLA_ENVIOS;

export const adaptEnvio = (envio) => {
  return {
    idOrdenPedido: envio.idOrdenPedido,
    idEvaluacion: envio.idEvaluacion,
    idPaciente: envio.idPaciente,
    paciente: envio.pacienteNombre,
    idCliente: envio.idCliente,
    estadoDescripcion: envio.estadoDescripcion,
    idDelegacion: envio.idDelegacion,
    delegacion: envio.delegacion,
    stockOrigen: envio.stockOrigen,
    stockOrigenOpcion: envio.stockOrigenOpcion,
    idDelegacionStockOrigen: envio.idDelegacionStockOrigen,
    delegacionStockOrigen: envio.delegacionStockOrigen,
    idModulo: envio.idModulo,
    conexionesSemanales: envio.conexionesSemanales,
    codSAP: envio.codSAPVenta,
    umeTolerancia: envio.umeTolerancia,
    umePorcentaje: envio.cantidadPorc,
    costoInsumos: envio.costoInsumos,
    costoUnitario: envio.costoUnitario,
    cantidadRemitos: envio.cantidadRemitos,
    gM: envio.gM,
    condicional: envio.resultadoPresupuesto,
    fechaEntrega: envio.fechaEntrega,
    fechaAutorizar: envio.fechaAutorizar,
    fechaAutorizado: envio.fechaAutorizado,
    nombreUsuarioAutorizar: envio.nombreUsuarioAutorizar,
    nombreUsuarioAutorizado: envio.nombreUsuarioAutorizado,
    estadoMedico: envio.estadoMedico,
    estadoBUM: envio.estadoBUM,
    estadoPEnvio: envio.estadoPEnvio,
    estadoComercial: envio.estadoComercial
  };
};

export const adaptEnviosArray = (envios) => {
  return structuredClone(envios)?.
  map((envio) => adaptEnvio(envio));
};